import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './orderpage.css';
import axios from 'axios';
import Sidebar from './sidebar';

const OrderPage = () => {
  const { id } = useParams();
  const [orderData, setOrderData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}v1/order_orderitems/${id}`, {
        headers: {
          'x-api-key': '12345xxa',
        },
      })
      .then((res) => {
        setOrderData(res.data);
      })
      .catch((error) => {
        console.error('Ошибка при получении данных о заказах:', error);
      });
  }, [id]);

  const handleEditOrder = () => {
    // Обработка нажатия на "Редактировать заказ"
  };

  const handleConfirmOrder = () => {
    // Обработка нажатия на "Подтвердить заказ"
  };

  const handleCancelOrder = () => {
    // Обработка нажатия на "Отменить заказ"
  };

  const handleAddContract = () => {
    navigate(`/orders/${id}/Invoice`, { state: { order: orderData } });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'не определена';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('ru-RU', options).format(date);
  };

  return (
    <div className="order-page-full">
      <div className="order-page-cont">
        <Sidebar />
        {orderData.slice(0, 1).map((order) => (
          <div className="order-page-container" key={order.Позиция}>
            <div className="order-header">
              <div>
                <h1>Заказ №{order.order_number || ''}</h1>
                <span className="order-status">Статус: {order.status_name || ''}</span>
              </div>
              <div className="header-buttons">
                <button className="create-invoice-btn" onClick={handleAddContract}>
                  вывести накладную
                </button>
                <button className="edit-order-btn" onClick={handleEditOrder}>Редактировать заказ</button>
                <button className="confirm-order-btn" onClick={handleConfirmOrder}>Подтвердить заказ</button>
                <button className="cancel-order-btn" onClick={handleCancelOrder}>Отменить заказ</button>
              </div>
            </div>

            <div className="order-info">
              <div className="order-details">
                <div><strong>Клиент:</strong> {order['Имя клиента'] || ''}</div>
                <div><strong>Договор:</strong> {order['Номер договора + дата договора + БИН'] || ''}</div>
                <div><strong>Адрес:</strong> {order['Адрес доставки'] || ''}</div>
                <div><strong>Дата доставки:</strong> {formatDate(order['Дата доставки (ориентировочная)'])}</div>
              </div>
              <div className="order-comments">
                <div><strong>Машина:</strong> {order.vehicle_name || ''}</div>
                <div><strong>Водитель:</strong> {order.driver_name || ''}</div>
                <div><strong>Статус оплаты:</strong> {order.payment_status || 'не определен'}</div>
              </div>
            </div>
          </div>
        ))}

        <table className="order-items">
          <thead>
            <tr>
              <th>Наименование</th>
              <th>Кол-во</th>
              <th>Ед. изм</th>
              <th>Цена</th>
              <th>Сумма</th>
            </tr>
          </thead>
          <tbody className="order-items-№">
            {orderData.map((item) => (
              <tr key={item.Позиция}>
                <td>{item['Товар']}</td>
                <td>{item['Количество']}</td>
                <td>{item.measure_name}</td>
                <td>{item['Цена']}</td>
                <td>{item.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="order-total">
          {orderData.slice(0, 1).map((item) => (
            <p key={item.Позиция}>Итого: {item.total_amount || ''}</p>
          ))}
        </div>
        <textarea
          className="order-comment"
          value={orderData.length > 0 ? orderData[0].client_commentary || '' : ''}
          onChange={(e) => {
            const newOrderData = [...orderData];
            if (newOrderData.length > 0) {
              newOrderData[0].client_commentary = e.target.value;
              setOrderData(newOrderData);
            }
          }}
          placeholder="Комментарий..."
        />
      </div>
    </div>
  );
};

export default OrderPage;
